export const YOUR_QUEUE_EVENT_CONTAINER_QUERY_KEY_ROOT =
    "home-your-queue-event-containers" as const;
